import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { IFilter, IFilterValue } from '../../_shared/models/filters.model';
import { IconComponent } from '../../icon/icon.component';

interface IAppliedFilterValue {
    filter: IFilter;
    value: IFilterValue;
}

interface IRemoveFilterRequest {
    filterId: string;
    valueId: string;
}

@Component({
    selector: 'sirius-filter-applied-filter',
    templateUrl: './filter-applied-filter.component.html',
    styleUrls: ['./filter-applied-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'sir-text-style-paragraph-m-default' },
    imports: [TranslateModule, IconComponent]
})
export class FilterAppliedFilterComponent implements OnChanges {
    @Input() filters: IFilter[] = [];

    appliedFilterValues: IAppliedFilterValue[] = [];

    /**
     * @emits string - the id of the filterValue to be deleted
     */
    @Output() deactivateFilterValue = new EventEmitter<IRemoveFilterRequest>();
    @Output() deactivateAllFilters = new EventEmitter<void>();

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['filters']) {
            this.updateAppliedFilterValues(this.filters);
        }
    }

    appliedFilterTrackKey(applied: IAppliedFilterValue): string {
        return `${applied.filter.id}:${applied.value.id}`;
    }

    getFiltersWithActiveValues(filters: IFilter[]) {
        return filters.filter((filter: IFilter) => filter.activeCount > 0);
    }

    getAllActiveFilterValues(filters: IFilter[]): IAppliedFilterValue[] {
        return filters.flatMap((filter: IFilter) =>
            filter.values
                .filter((value: IFilterValue) => value.active)
                .map((value: IFilterValue) => ({ filter, value }))
        );
    }

    updateAppliedFilterValues(filters: IFilter[]): void {
        const activeFilters = this.getFiltersWithActiveValues(filters);
        this.appliedFilterValues = this.getAllActiveFilterValues(activeFilters);
    }

    onRemoveFilterIconClicked(filterId: string, valueId: string) {
        this.deactivateFilterValue.emit({
            filterId: filterId,
            valueId: valueId,
        });
    }

    onClearButtonClicked() {
        this.deactivateAllFilters.emit();
    }
}
